import * as React from 'react'
import '../styles/App.scss'
import '../styles/App-media.scss'
import '../styles/Footer.scss'
import { FlatButton } from 'material-ui'
import { StickyContainer, Sticky } from 'react-sticky'

interface Footerprops {
  setLocation?: () => void
  setJobLocation: () => void
  disabled: boolean
}

export default class Footer extends React.Component<Footerprops, {}> {
  render() {
    return (
      <StickyContainer className="sticky-footer sb map-button" >
        <Sticky>
          {() => (
            <div className={'bottom-part hover'}>
              <FlatButton
                label="Set Job Location"
                className={this.props.disabled ? 'flatbutton disabled' : 'flatbutton'}
                disabled={this.props.disabled}
                onClick={this.props.setJobLocation}
              />
            </div>
          )}
        </Sticky>
      </StickyContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.tsx